import { render, staticRenderFns } from "./ChangeLanguageIconPc.vue?vue&type=template&id=23607802&scoped=true&"
import script from "./ChangeLanguageIconPc.vue?vue&type=script&lang=ts&"
export * from "./ChangeLanguageIconPc.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeLanguageIconPc.vue?vue&type=style&index=0&id=23607802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23607802",
  null
  
)

export default component.exports